import React, { useState } from "react";
import { useSelector } from "react-redux";
import { imageURL } from "../../api/index";

import SpecialButton from "../UI/SpecialButton";

import Image from "../../assets/images/profile-avatar.jpg";
import "./Topbar.scss";
import { ReactSVG } from "react-svg";
import { Link } from "react-scroll";
import { Link as RouterLink, NavLink } from "react-router-dom";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";

const Topbar = ({ setShowDropDown, showDropDown }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  const auth = localStorage.getItem("auth");
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  // console.log(user.patient.profilePicture)
  const firstName = useSelector((state) => {
    if (isAuthenticated) {
      return state.auth.user.patient.firstName;
    }
    return null;
  });
  const lastName = useSelector((state) => {
    if (isAuthenticated) {
      return state.auth.user.patient.lastName;
    }
    return null;
  });

  const logoutHandler = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("auth");
    window.location.reload();
  };

  return (
    <>
      <div className="topbar-main-container">
        <div className="tobpar-top">
          <div className="topbar-top-item">
            <ReactSVG src="/icons/tools/mail.svg" />
            <a href="mailto:Provider@secondlookortho.com">
              Provider@secondlookortho.com
            </a>
          </div>
          <hr />
          <div className="topbar-top-item">
            <ReactSVG src="/icons/tools/phone.svg" />
            <a href="tel:+18008402046">1 (800)840-2046</a>
          </div>
        </div>
        <div className="topbar-main">
          <div className="topbar-main-left">
            <ReactSVG src="/icons/menu/orthologo.svg" />
          </div>
          <div className="topbar-main-right">
            <div className="main-content-wrapper">
              <div className="menu-content">
                <nav>
                  <ul>
                    <li>
                      <Link
                        to="home"
                        spy={true}
                        smooth={true}
                        offset={-95}
                        duration={200}
                        activeClass="active"
                      >
                        HOME
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="how-it-works"
                        spy={true}
                        smooth={true}
                        offset={-95}
                        duration={200}
                        activeClass="active"
                      >
                        HOW IT WORKS
                      </Link>
                    </li>
                    <li>
                      <Link
                        activeClass="active"
                        spy={true}
                        smooth={true}
                        offset={-95}
                        duration={200}
                        to="reviews"
                      >
                        ABOUT US
                      </Link>
                    </li>
                    <li>
                      <Link
                        activeClass="active"
                        spy={true}
                        smooth={true}
                        offset={-95}
                        duration={200}
                        to="faqs"
                      >
                        FAQs
                      </Link>
                    </li>
                    <li>
                      <Link
                        activeClass="active"
                        spy={true}
                        smooth={true}
                        offset={-95}
                        duration={200}
                        to="our-team"
                      >
                        MY INFORMATION
                      </Link>
                    </li>
                    <li>
                      <Link
                        activeClass="active"
                        spy={true}
                        smooth={true}
                        offset={-95}
                        duration={200}
                        to="contact-us"
                      >
                        CONTACT US
                      </Link>
                    </li>
                    <li>
                      <NavLink to="/Blogs">BLOGS</NavLink>
                    </li>
                  </ul>
                </nav>
              </div>
              <hr />
              {auth ? (
                <div
                  class="profile-dropdown"
                  onClick={() => setShowDropDown(!showDropDown)}
                >
                  <div className="flex align-items-center">
                    <img
                      src={
                        user?.patient?.profilePicture
                          ? `${imageURL}/${user?.patient?.profilePicture}`
                          : Image
                      }
                      className="avatar-img-topbar  mr-[10px]"
                      alt=""
                    />
                    {isAuthenticated && (
                      <span className="">{`${firstName} ${lastName}`} </span>
                    )}
                  </div>
                </div>
              ) : (
                <RouterLink to={"./sign-in"} className="login-button-link">
                  <button>
                    <ReactSVG src="/icons/tools/button-arrow.svg" />
                    <p>LOGIN</p>
                  </button>
                </RouterLink>
              )}
            </div>

            {/* BURGER MENU */}
            {!isOpen ? (
              <ReactSVG
                onClick={toggleDrawer}
                className="burger-menu"
                src="/icons/tools/burger-menu.svg"
              />
            ) : (
              <ReactSVG
                onClick={toggleDrawer}
                className="burger-menu"
                src="/icons/tools/cross.svg"
              />
            )}
          </div>
        </div>
      </div>
      <Drawer
        className="drawer-menu"
        open={isOpen}
        onClose={toggleDrawer}
        direction="left"
        lockBackgroundScroll={true}
        size={300}
      >
        <div className="mobile-menu">
          <div className="menu-content">
            <nav>
              <ul>
                <li>
                  <Link
                    to="home"
                    spy={true}
                    smooth={true}
                    offset={-95}
                    duration={200}
                    activeClass="active"
                  >
                    HOME
                  </Link>
                </li>
                <li>
                  <Link
                    to="how-it-works"
                    spy={true}
                    smooth={true}
                    offset={-95}
                    duration={200}
                    activeClass="active"
                  >
                    HOW IT WORKS
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="active"
                    spy={true}
                    smooth={true}
                    offset={-95}
                    duration={200}
                    to="reviews"
                  >
                    ABOUT US
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="active"
                    spy={true}
                    smooth={true}
                    offset={-95}
                    duration={200}
                    to="faqs"
                  >
                    FAQs
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="active"
                    spy={true}
                    smooth={true}
                    offset={-95}
                    duration={200}
                    to="our-team"
                  >
                    MY INFORMATION
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="active"
                    spy={true}
                    smooth={true}
                    offset={-95}
                    duration={200}
                    to="contact-us"
                  >
                    CONTACT US
                  </Link>
                </li>
                <li>
                  <NavLink to="/Blogs">BLOGS</NavLink>
                </li>
              </ul>
            </nav>
          </div>
          {auth ? (
            <>
              {/* <div className="flex">
                <img
                  src={
                    user?.patient?.profilePicture
                      ? `${imageURL}/${user?.patient?.profilePicture}`
                      : Image
                  }
                  className="avatar-img  mr-[5px]"
                  alt=""
                />
                {isAuthenticated && (
                  <span className="mt-[3px] nameandsurname">
                    {`${firstName} ${lastName}`}{" "}
                  </span>
                )}
              </div> */}
              <div className="menu-bottom">
                <RouterLink to="/dashboard">
                  <button>Dashboard</button>
                </RouterLink>
                <button onClick={logoutHandler}>Logout</button>
              </div>
            </>
          ) : (
            // <RouterLink to={"./sign-in"}>
            //   {/* <button> */}

            //   {/* </button> */}
            //   </RouterLink>
            <SpecialButton
              buttonAsLink={true}
              link={"./sign-in"}
              className="login-button-special"
            >
              <p>LOGIN</p>
            </SpecialButton>
          )}
        </div>
      </Drawer>
    </>
  );
};

export default Topbar;
